import { Grid } from '@mui/material';
import BodyTemplate from 'components/_layout/navigation/BodyTemplate';
import { useIsRelative } from 'hooks';
import { Person, ShortenPerson } from 'models/profile.model';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { GlobalState } from 'store/reducers';
import IndexMyProfile from './IndexMyProfile';
import IndexProfileTabSwitcher from './IndexProfileTabSwitcher';
import IndexRelativeProfile from './IndexRelativeProfile';

const Profile: FC<{ profileType: string }> = ({ profileType }) => {
  const { t } = useTranslation();
  const currentUser = useSelector((state: GlobalState) => state.session.currentUser as ShortenPerson);
  const relativesCurrentUser = useSelector((state: GlobalState) => state.session.relativesCurrentUser as Person[]);
  const isRelative = useIsRelative();

  return (
    <BodyTemplate title={profileType === 'me' ? t('bodyTemplate.myProfile') : t('bodyTemplate.myRelatives')}>
      <Grid container columnSpacing={2} rowSpacing={3}>
        {!isRelative && <IndexProfileTabSwitcher profileType={profileType} />}
        {profileType === 'me' ? <IndexMyProfile currentUser={currentUser} /> : <IndexRelativeProfile relativesCurrentUser={relativesCurrentUser} />}
      </Grid>
    </BodyTemplate>
  );
};

export default Profile;
